import { Instagram, CreditCard, Banknote, QrCode } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#132034] text-[#fcfcfb] py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-5">
          <div>
            <h3 className="font-['MontserratAlt1'] font-light  text-xl mb-4">
              A Bordo Viagens
            </h3>
            <p className="text-[#dbd2c9]">
            Seja para negócios ou descanso, levamos você!
            </p>
          </div>

          <div>
            <h4 className="font-['MontserratAlt1'] font-light text-lg mb-4">Siga-nos</h4>
            <a
              href="https://www.instagram.com/a.bordoviagens/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 text-[#dbd2c9] hover:text-white transition-colors"
            >
              <Instagram className="w-5 h-5" />
              <p>a.bordoviagens</p>
            </a>
          </div>
          <div>
            <h4 className="font-['MontserratAlt1'] font-light text-lg mb-4">Parceiros</h4>
            <div className="space-y-3">
              <a
                href="https://fronturbhz.com.br/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-[#dbd2c9] hover:text-white transition-colors"
              >
                <img 
                  src="/parceiros/fronturb.svg" 
                  alt="Fronturb" 
                  className="w-24 h-auto object-contain brightness-200 hover:brightness-100 transition-all"
                />
              </a>
              <a
                href="https://hoteldo.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-[#dbd2c9] hover:text-white transition-colors"
              >
                <img 
                  src="/parceiros/hoteldo.webp" 
                  alt="HotelDO" 
                  className="w-24 h-auto object-contain brightness-200 hover:brightness-100 transition-all"
                />
              </a>
            </div>
          </div>
          <div>
            <h4 className="font-['MontserratAlt1'] font-light text-lg mb-4">Formas de Pagamento</h4>
            <div className="space-y-2">
              <div className="flex items-center space-x-2 text-[#dbd2c9]">
                <QrCode className="w-5 h-5" />
                <p>PIX</p>
              </div>
              <div className="flex items-center space-x-2 text-[#dbd2c9]">
                <Banknote className="w-5 h-5" />
                <p>Boleto</p>
              </div>
              <div className="flex items-center space-x-2 text-[#dbd2c9]">
                <CreditCard className="w-5 h-5" />
                <p>Cartões</p>
              </div>
            </div>
          </div>
          <div>
            <h4 className="font-['MontserratAlt1'] font-light text-lg mb-4">Contato</h4>
            <p className="text-[#dbd2c9]">Ponta Grossa - PR - Brasil</p>
            <p className="text-[#dbd2c9]">WhatsApp: +55 42 99941-7643</p>
            <p className="text-[#dbd2c9]">contato@abordoviagens.com</p>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-[#dbd2c9]/20 text-center text-[#dbd2c9]">
          <p>
            &copy; {new Date().getFullYear()} A Bordo Viagens. Todos os direitos
            reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}
